
import { serviceAreas } from '../../../mocks/serviceAreas';

const ServiceAreas = () => {
  const featuredAreas = serviceAreas.filter((area) => area.featured);

  return (
    <section className="py-20 bg-greenbg">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-charcoal mb-6">
              Serving All of KwaZulu-Natal
            </h2>
            <p className="text-gray-700 text-lg mb-6 leading-relaxed">
              Look Who's Moving provides reliable bakkie removals and landscaping services throughout KwaZulu-Natal. From urban centers like Durban and Pinetown to rural communities across the province, we deliver professional transport and garden services with transparent pricing and insured vehicles.
            </p>
            <p className="text-gray-700 text-lg mb-8 leading-relaxed">
              Whether you need furniture transport in Westville, long-distance removals to Pietermaritzburg, or landscaping services in Hillcrest, our experienced team is ready to help. We specialize in both urban and rural service delivery across KZN.
            </p>
            <a
              href="https://wa.me/27798768956"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-primary text-white px-8 py-4 rounded-full font-semibold hover:bg-primary-dark transition-colors whitespace-nowrap cursor-pointer"
            >
              Request Service Quote
            </a>
          </div>

          <div>
            <div className="bg-white rounded-2xl shadow-lg p-8">
              <h3 className="font-bold text-2xl text-charcoal mb-6">Key Service Areas</h3>
              <div className="grid grid-cols-2 gap-4">
                {featuredAreas.map((area) => (
                  <div
                    key={area.id}
                    className="flex items-center space-x-3 p-3 bg-greenbg rounded-lg hover:bg-primary/10 transition-colors"
                  >
                    <i className="ri-map-pin-fill text-primary text-xl w-6 h-6 flex items-center justify-center"></i>
                    <span className="font-medium text-charcoal">{area.name}</span>
                  </div>
                ))}
              </div>
              <div className="mt-6 pt-6 border-t border-gray-200">
                <p className="text-gray-600 text-sm mb-3">
                  <strong className="text-charcoal">Plus many more areas including:</strong> Phoenix, Chatsworth, Queensburgh, Kloof, Gillitts, Waterfall, Pietermaritzburg, and rural KZN communities
                </p>
                <a
                  href="tel:+27798768956"
                  className="text-primary font-semibold hover:text-primary-dark transition-colors cursor-pointer"
                >
                  Call to confirm your area →
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
